import isEmpty from './isEmpty'
import isNumber from './isNumber'
//------------------
// build damage mod
//------------------
export default function buildDamageMod(parm) {
  // console.log('------------------------')
  // console.log('IN buildDamageMod')

  // console.log('parm.base = ', parm.base, ' type = ', typeof parm.base)
  // console.log('parm.adjs_tot = ', parm.adjs_tot, ' type = ', typeof parm.adjs_tot)
  // ------
  // vars
  // ------
  let base_numberBeforeD = 0
  let adjs_tot_numberBeforeD = 0

  let base_numberAfterD = 0
  let adjs_tot_numberAfterD = 0

  let base_numberAfterPlus = 0
  let adjs_tot_numberAfterPlus = 0

  let base_numberAfterMinus = 0
  let adjs_tot_numberAfterMinus = 0

  let base_number = 0
  let adjs_tot_number = 0

  // let sign = ''
  let totD = 0
  let totTrailing = 0

  let result
  // =========================================
  // FUNCTIONS
  // =========================================
  // ---------------------------------
  // get number relative to character
  // ---------------------------------
  function getNumberRelativeToChar(str, char, direction = 'after') {
    /* REGEX BREAKDOWN:
        ------------------------------------------------------------------------
            / ... /i    — pattern is case-insensitive (i flag)
            D           — matches  letter "D" (uppercase or lowercase due to i)
            \s*         — matches zero or more whitespace characters after "D"
            ([+-]?\d+)  — capturing group....
                    [+-]?       — optionally matches a plus or minus sign
                    \d+         — matches one or more digits.
        ------------------------------------------------------------------------
        const afterDMatch = base_str.match(/D\s*([+-]?\d+)/i)
      */
    // allow special chars to work
    const safeChar = char.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    let regex
    // -----------------
    // AFTER char regex
    // -----------------
    if (direction === 'after') {
      // get number after the char (e.g., D+2, D-1, D6)
      regex = new RegExp(safeChar + '\\s*([+-]?\\d+)', 'i')
      // ------------------
      // BEFORE char regex
      // ------------------
    } else if (direction === 'before') {
      // Match number before the char (e.g., 2D, -1D)
      regex = new RegExp('(-?\\d+)\\s*' + safeChar, 'i')
      // --------------
      // OTHERWISE bail
      // ---------------
    } else {
      return null
    }
    // --------------
    // perform match
    // --------------
    const match = str.match(regex)
    // --------------
    // return number
    // --------------
    return match ? parseInt(match[1], 10) : null
  }
  // ---------------
  // get die result
  // ---------------
  function getDieResult(parm) {
    //
    let base_numberBeforeD = parm.base_numberBeforeD
    let base_numberAfterD = parm.base_numberAfterD
    let adjs_tot_numberBeforeD = parm.adjs_tot_numberBeforeD
    let adjs_tot_numberAfterD = parm.adjs_tot_numberAfterD
    //
    let type = parm.type
    let base_totD
    let adjs_tot_totD
    let result
    //
    // console.log('getDieResult 0 - type = ', type)
    // -----------------------------
    // check leading base D numbers
    // -----------------------------
    if (base_numberBeforeD > 0) {
      base_totD = base_numberBeforeD + 'D' + base_numberAfterD
      // console.log('getDieResult 1 - base_totD = ', base_totD)
    } else {
      base_totD = 'D' + base_numberAfterD
      // console.log('getDieResult 2 - base_totD = ', base_totD)
    }
    // ---------------------------------
    // check leading adjs_tot D numbers
    // ---------------------------------
    if (adjs_tot_numberBeforeD > 0) {
      adjs_tot_totD = adjs_tot_numberBeforeD + 'D' + adjs_tot_numberAfterD
      // console.log('getDieResult 3 - adjs_tot_totD = ', adjs_tot_totD)
    } else {
      adjs_tot_totD = 'D' + adjs_tot_numberAfterD
      // console.log('getDieResult 4 - adjs_tot_totD = ', adjs_tot_totD)
    }
    // -------------
    // build result
    // -------------
    if (type == 'both') {
      result = base_totD + '+' + adjs_tot_totD
    } else if (type == 'base') {
      result = base_totD
    } else if (type == 'adjs_tot') {
      result = adjs_tot_totD
    }
    // console.log('getDieResult 5 - result = ', result)
    return result
  }
  // =========================================
  // INITIAL CHECKS
  // =========================================
  // ---------------------------
  // both empty = return null
  // ---------------------------
  if (isEmpty(parm.base) && isEmpty(parm.adjs_tot)) {
    // console.log('buildDamageMod 1')
    return null
    // ---------------------------
    // base empty = return adj
    // ---------------------------
  } else if (isEmpty(parm.base)) {
    // console.log('buildDamageMod 2')
    return parm.adjs_tot
    // ---------------------------
    // adj empty = return base
    // ---------------------------
  } else if (isEmpty(parm.adjs_tot)) {
    // console.log('buildDamageMod 3')
    return parm.base
    // =========================================
    // BOTH PARMS PRESENT
    // =========================================
  } else {
    // -----
    // prep
    // -----
    // console.log('buildDamageMod 4')
    const base_str = parm.base.toString()
    const adjs_tot_str = parm.adjs_tot.toString()
    //
    const base_die = base_str.includes('D')
    const adjs_tot_die = adjs_tot_str.includes('D')
    //
    const base_plus = base_str.includes('+')
    const adjs_tot_plus = adjs_tot_str.includes('+')

    const base_minus = base_str.includes('-')
    const adjs_tot_minus = adjs_tot_str.includes('-')

    // console.log('base_die = ', base_die)
    // console.log('adjs_tot_die = ', adjs_tot_die)
    // ------------------
    // D present in base
    // ------------------
    if (base_die) {
      // console.log('buildDamageMod 5 - base_die = ', base_die)
      // -------------------
      // get number after D
      // -------------------
      base_numberAfterD = getNumberRelativeToChar(base_str, 'D', 'after')
      // console.log('buildDamageMod 6 - base number after D:', base_numberAfterD)
      // -------------------------------
      // get number before die (if any)
      // -------------------------------
      base_numberBeforeD = getNumberRelativeToChar(base_str, 'D', 'before')
      // console.log('buildDamageMod 7 - base number before D:', base_numberBeforeD)
    }
    // console.log('buildDamageMod 8...')
    // ----------------------
    // D present in adjs_tot
    // ----------------------
    if (adjs_tot_die) {
      // console.log('buildDamageMod 9 - adjs_tot_die = ', adjs_tot_die)
      // ---------------------
      // get number after die
      // ---------------------
      adjs_tot_numberAfterD = getNumberRelativeToChar(adjs_tot_str, 'D', 'after')
      // console.log('buildDamageMod 10 - adjs_tot number after D:', adjs_tot_numberAfterD)
      // }
      // -------------------------------
      // get number before die (if any)
      // -------------------------------
      adjs_tot_numberBeforeD = getNumberRelativeToChar(adjs_tot_str, 'D', 'before')
      // console.log('buildDamageMod 11 - adj_tot number before D:', adjs_tot_numberBeforeD)
      // }
    }
    // console.log('buildDamageMod 12...')
    // ---------------
    // base is number
    // ---------------
    if (isNumber(parm.base)) {
      // console.log('buildDamageMod 12a')
      base_number = parm.base
    }
    // -------------------
    // adjs_tot is number
    // -------------------
    if (isNumber(parm.adjs_tot)) {
      // console.log('buildDamageMod 12b')
      adjs_tot_number = parm.adjs_tot
    }
    // ---------------------
    // plus present in base
    // ---------------------
    if (base_plus) {
      // console.log('buildDamageMod 13')
      base_numberAfterPlus = getNumberRelativeToChar(base_str, '+', 'after')
      // console.log('buildDamageMod 14 - base number after +:', base_numberAfterPlus)
    }
    // ----------------------
    // minus present in base
    // ----------------------
    if (base_minus && base_die) {
      // console.log('buildDamageMod 13b')
      base_numberAfterMinus = getNumberRelativeToChar(base_str, '-', 'after')
      // console.log('buildDamageMod 14b - base number after -:', base_numberAfterMinus)
    }
    // ---------------------
    // plus present in adjs
    // ---------------------
    if (adjs_tot_plus) {
      // console.log('buildDamageMod 15')
      adjs_tot_numberAfterPlus = getNumberRelativeToChar(adjs_tot_str, '+', 'after')
      // console.log('buildDamageMod 16 - adjs_tot number after +:', adjs_tot_numberAfterPlus)
    }
    // ----------------------
    // minus present in adjs
    // ----------------------
    if (adjs_tot_minus && adjs_tot_die) {
      // console.log('buildDamageMod 15b')
      adjs_tot_numberAfterMinus = getNumberRelativeToChar(adjs_tot_str, '-', 'after')
      // console.log('buildDamageMod 16b - adjs_tot number after -:', adjs_tot_numberAfterMinus)
    }
    // console.log('buildDamageMod 17...')
    // console.log('========================================')
    // ---------------
    // def die parm
    // ---------------
    let die_parm = {
      base_numberBeforeD: base_numberBeforeD,
      base_numberAfterD: base_numberAfterD,
      adjs_tot_numberBeforeD: adjs_tot_numberBeforeD,
      adjs_tot_numberAfterD: adjs_tot_numberAfterD,
      type: null,
    }
    // =========================================
    // BOTH HAVE D's
    // =========================================
    if (base_die && adjs_tot_die) {
      // console.log('buildDamageMod 18 - both Ds')
      // =========================================
      // D's same (numbers after D)
      // =========================================
      if (base_numberAfterD == adjs_tot_numberAfterD) {
        // console.log('buildDamageMod 19 - Ds same')
        // ------------------------------------------------
        // both parms have numbers before D (add together)
        // ------------------------------------------------
        if (base_numberBeforeD > 0 && adjs_tot_numberBeforeD > 0) {
          totD = base_numberBeforeD + adjs_tot_numberBeforeD
          // console.log(
          //   'buildDamageMod 20 - base_numberBeforeD = ',
          //   base_numberBeforeD,
          //   ' adjs_tot_numberBeforeD = ',
          //   adjs_tot_numberBeforeD,
          //   ' totD = ',
          //   totD,
          // )
          // ---------------------------------------------
          // both parms have NO numbers before D (just 2)
          // ---------------------------------------------
        } else if (base_numberBeforeD == 0 && adjs_tot_numberBeforeD == 0) {
          totD = 2
          console.log(
            'buildDamageMod 21 - base_numberBeforeD = ',
            base_numberBeforeD,
            ' adjs_tot_numberBeforeD = ',
            adjs_tot_numberBeforeD,
            ' totD = ',
            totD,
          )
          // ----------------------------------------------
          // only base has number before D (add 1 to base)
          // ----------------------------------------------
        } else if (base_numberBeforeD > 0) {
          totD = base_numberBeforeD + 1
          console.log(
            'buildDamageMod 22 - base_numberBeforeD = ',
            base_numberBeforeD,
            ' adjs_tot_numberBeforeD = ',
            adjs_tot_numberBeforeD,
            ' totD = ',
            totD,
          )
          // ---------------------------------------------------
          // only adjs_tot has number before D (add 1 for base)
          // ---------------------------------------------------
        } else if (adjs_tot_numberBeforeD > 0) {
          totD = adjs_tot_numberBeforeD + 1
          console.log(
            'buildDamageMod 23 - base_numberBeforeD = ',
            base_numberBeforeD,
            ' adjs_tot_numberBeforeD = ',
            adjs_tot_numberBeforeD,
            ' totD = ',
            totD,
          )
        }
        // --------------------------
        // die result (D's are same)
        // --------------------------
        result = totD + 'D' + base_numberAfterD
        // console.log('buildDamageMod 24 - result = ', result)
        //
      } else {
        // =========================================
        // D's are different
        // =========================================
        // console.log('buildDamageMod 25... base_die =', base_die, ' adjs_tot_die = ', adjs_tot_die)
        // ---------------
        // get die result
        // ---------------
        die_parm.type = 'both'
        result = getDieResult(die_parm)
      }
      // =========================================
      // ONLY BASE HAS D
      // =========================================
    } else if (base_die) {
      // console.log('buildDamageMod 26... ')
      // ---------------
      // get die result
      // ---------------
      die_parm.type = 'base'
      result = getDieResult(die_parm)
      // console.log('buildDamageMod 27 result = ', result)
      // =========================================
      // ONLY ADJS_TOT HAS D
      // =========================================
    } else if (adjs_tot_die) {
      // ---------------
      // get die result
      // ---------------
      die_parm.type = 'adjs_tot'
      result = getDieResult(die_parm)
      // console.log('buildDamageMod 26 result = ', result)
      // =========================================
      // NO D's
      // =========================================
    } else {
      result = Number(parm.base) + Number(parm.adjs_tot)
      // console.log('buildDamageMod 28 result = ', result)
    }
    // =========================================
    // RESOLVE RESULTS
    // =========================================
    if (!base_die && !adjs_tot_die) {
      // console.log('buildDamageMod 29 result = ', result)
      return result
      // ---------------------------------
      // either parm has trailing numbers
      // ---------------------------------
    } else if (
      base_numberAfterPlus !== 0 ||
      adjs_tot_numberAfterPlus !== 0 ||
      base_numberAfterMinus !== 0 ||
      adjs_tot_numberAfterMinus !== 0 ||
      base_number !== 0 ||
      adjs_tot_number !== 0
    ) {
      // console.log('>>>==================================')
      // console.log('base_numberAfterPlus = ', base_numberAfterPlus)
      // console.log('adjs_tot_numberAfterPlus = ', adjs_tot_numberAfterPlus)
      // console.log('base_numberAfterMinus = ', base_numberAfterMinus)
      // console.log('adjs_tot_numberAfterMinus = ', adjs_tot_numberAfterMinus)
      // console.log('base_number = ', base_number)
      // console.log('adjs_tot_number = ', adjs_tot_number)
      // console.log('>>>==================================')
      totTrailing =
        base_numberAfterPlus +
        adjs_tot_numberAfterPlus +
        base_numberAfterMinus * -1 +
        adjs_tot_numberAfterMinus * -1 +
        Number(base_number) +
        Number(adjs_tot_number)
      // console.log('buildDamageMod 30 totTrailing = ', totTrailing)
      // --------------------------------------
      // no trailing numbers - just return D's
      // --------------------------------------
    } else if (base_numberAfterPlus == 0 && adjs_tot_numberAfterPlus == 0) {
      // console.log('buildDamageMod 31 result = ', result)
      return result
    }
    // ---------------------------
    // add & append to die result
    // ---------------------------
    if (totTrailing !== 0) {
      // console.log('buildDamageMod 31')
      if (result != '') {
        // console.log('buildDamageMod 32 result = ', result)
        if (totTrailing > 0) {
          result += '+' + totTrailing.toString()
          // console.log('buildDamageMod 33 result = ', result)
        } else {
          result += totTrailing.toString()
          // console.log('buildDamageMod 34 result = ', result)
        }
        // console.log('buildDamageMod 35 result = ', result)
        return result
      } else {
        // ----------------
        // just return sum
        // ----------------
        result = totTrailing.toString()
        // console.log('buildDamageMod 36 result = ', result)
        return totTrailing.toString()
      }
    } else {
      // ----------------
      // just return dies
      // ----------------
      // console.log('buildDamageMod 37 result = ', result)
      return result
    }
  }
}